import Button from 'components/common/Button';
import { useState, useMemo } from 'react';
import useBottomSheet from 'hooks/common/useBottomSheet';
import ToastBridge from 'bridges/toastBridge';
import BlockReportConfirm from './BlockReportConfirm';
import { createPortal } from 'react-dom';
import useBlockReport from 'hooks/profile/useBlockReport';

type ReportType = 'block' | 'report';

const BlockReportMenu = () => {
  const { getSheet } = useBottomSheet();
  const { close } = useBottomSheet();
  const sheet = getSheet('BlockReportMenu');
  const userInfo = sheet.data.userInfo;
  const [reportType, setReportType] = useState<ReportType | null>(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const { blockUser, reportProfile } = useBlockReport();

  const handleReportAction = async () => {
    const param = {
      title: brsc.report_menu_result,
      btnNum: 1,
      btnName: brsc.confirm2,
      classname: ['report-popup'],
    };
    const REPORT_MESSAGE = brsc.report_room_result2;

    if (reportType === 'block') {
      const successBlock = await blockUser(userInfo.fbUid);
      if (successBlock) {
        showToast();
        setShowOverlay(true);
        setTimeout(() => {
          close('BlockReportMenu');
          close('UserProfile');
          setShowOverlay(false);
        }, 1000);
      }
    } else if (reportType === 'report') {
      const successReport = await reportProfile(userInfo);
      if (successReport) {
        close('BlockReportMenu');
        close('UserProfile');
        CommonUI.showDialogV2(REPORT_MESSAGE, param, () => { });
      }
    }
  };

  const showToast = () => {
    ToastBridge.add({
      text: brsc.noti_blocked,
      options: {
        duration: 2000,
        position: 'top',
        type: 'default',
      },
    });
  };

  const portalRoot = useMemo(() => {
    return document.getElementById('hMainContainer') || document.body;
  }, []);

  return (
    <>
      {showOverlay && portalRoot && createPortal(<div className="fixed inset-0 z-[102] bg-base-bg-default"></div>, portalRoot)}
      {reportType ? (
        <div className="mb-[32px] flex h-fit w-full flex-col gap-6">
          <BlockReportConfirm type={reportType} userInfo={userInfo} onClose={() => close('BlockReportMenu')} onConfirm={handleReportAction} />
        </div>
      ) : (
        <div className="mb-[32px] flex h-fit w-full flex-col gap-6">
          <div className="typography-body-sm text-center text-base-txt-secondary">{brsc.report_contents_1}</div>
          <div className="flex w-full gap-3">
            <Button
              onClick={() => setReportType('block')}
              className="gap-1"
              style={{
                text: brsc.block,
                type: 'solid',
                color: 'btn-bg-normal',
                fontColor: 'base-txt-primary',
                icon: { name: 'tutorial/ic_block_white.svg', size: 24 },
                borderRadius: 'full',
              }}
            />
            <Button
              onClick={() => setReportType('report')}
              className="gap-1"
              style={{
                text: brsc.report_2,
                type: 'solid',
                color: 'btn-bg-alert',
                fontColor: 'base-txt-primary',
                icon: { name: 'profile/report.svg', size: 24 },
                borderRadius: 'full',
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BlockReportMenu;